<template>
  <div class="project-one-summary-view">
    <project-one-summary-preview />
    <project-one-summary-details :base-properties="bpData" />
  </div>
</template>

<script>
import ProjectOneSummaryPreview from '@/projectOne/components/summary/ProjectOneSummaryPreview';
import ProjectOneSummaryDetails from '@/projectOne/components/summary/ProjectOneSummaryDetails';

export default {
  components: {ProjectOneSummaryPreview, ProjectOneSummaryDetails},
};
</script>

<style lang="scss" scoped>
.project-one-summary-view {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  @screen lg {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
}
</style>
